module.exports = __webpack_public_path__ + "img/col.3b252a1a.svg";